import Home from '../Pages/Home/Home';
import TimeClock from '../Pages/TimeClock/TimeClock';
import Timesheets from '../Pages/Timesheets/Timesheets';
import ClockIc from '../Pages/ClockIc';
import ClockOut from '../Pages/ClockOut';

// Страницы для админ-раздела:
import AdminPanel from '../Pages/Admin/AdminPanel';
import OrganizationList from '../Pages/Admin/OrganizationList';
import DepartmentList from '../Pages/Admin/DepartmentList';
import TeamList from '../Pages/Admin/TeamList';
import UserManagement from '../Pages/Admin/UserManagement';
import TimesheetDetail from '../Pages/Admin/TimesheetDetail';
import EntityTimesheetDetail from '../Pages/Admin/EntityTimesheetDetail';
import AllowedLocationsMap from '../Pages/Admin/AllowedLocationsMap';
import ScheduleList from '../Pages/Admin/ScheduleList'; // Новый импорт

const authProtectedRoutes = [
  // Основные публичные маршруты
  { path: "/", component: <Home />, allowedRoles: ['admin', 'ceo', 'hr', 'hod', 'manager', 'supervisor'] },
  { path: "/clock", component: <TimeClock />, allowedRoles: ['admin', 'ceo', 'hr', 'hod', 'manager', 'supervisor'] },
  { path: "/report", component: <Timesheets />, allowedRoles: ['admin', 'ceo', 'hr', 'hod', 'manager', 'supervisor'] },
  { path: "/clock_ic", component: <ClockIc />, allowedRoles: ['admin', 'ceo', 'hr', 'hod', 'manager', 'supervisor'] },
  { path: "/clock_out", component: <ClockOut />, allowedRoles: ['admin', 'ceo', 'hr', 'hod', 'manager', 'supervisor'] },

  // Админ-панель
  { path: "/admin", component: <AdminPanel />, allowedRoles: ['admin', 'ceo'] },
  { path: "/admin/allowed_locations", component: <AllowedLocationsMap />, allowedRoles: ['admin'] },

  // Организации
  { path: "/admin/org_list", component: <OrganizationList />, allowedRoles: ['admin', 'ceo', 'hr'] },

  // Департаменты
  { path: "/admin/dept_list", component: <DepartmentList />, allowedRoles: ['admin', 'ceo', 'hod', 'supervisor'] },

  // Команды
  { path: "/admin/team_list", component: <TeamList />, allowedRoles: ['admin', 'ceo', 'manager', 'supervisor'] },

  // Пользователи
  { path: "/admin/user_management", component: <UserManagement />, allowedRoles: ['admin', 'ceo'] },

  // Детали табеля
  { path: "/admin/timesheet_detail/:id", component: <TimesheetDetail />, allowedRoles: ['admin', 'ceo'] },

  // Таймшит по entity_type (org/dep/team) и entity_id
  {
    path: "/admin/entity_timesheet_detail/:entity_type/:entity_id",
    component: <EntityTimesheetDetail />,
    allowedRoles: ['admin', 'ceo', 'hr', 'hod', 'manager', 'supervisor'],
  },

  // Новый маршрут для списка расписаний
  { path: "/admin/schedule_list", component: <ScheduleList />, allowedRoles: ['admin'] },
];

const publicRoutes = [
  { path: "/404", component: <Timesheets /> },
];

export { authProtectedRoutes, publicRoutes };
